import { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import colors from '@o2/ui/theme/colors';

export interface LayoutSideBarProps {
  children: ReactNode;
  'data-elm'?: string;
}

const StyledSidebar = styled('aside', {
  name: 'Layout',
  slot: 'Sidebar',
})(() => ({
  position: 'sticky',
  top: 0,
  backgroundColor: colors.transparentWhite[300],
}));

const LayoutSideBar: FC<LayoutSideBarProps> = ({ children, 'data-elm': dataElm }) => {
  return <StyledSidebar data-elm={dataElm}>{children}</StyledSidebar>;
};

export default LayoutSideBar;
